import { theme as _theme } from '@amply-app/chakra';
import { extendTheme } from '@chakra-ui/react';

export const theme = extendTheme(_theme);
